import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API() + 'vFaktury/';

let URL_CLIENT = AppConfig.HOST_CLIENT_API() + 'faktury/';

export default {

    getFakturyBilety(params) {
        return axios({
            method: 'get',
            url: (Boolean(params.nipLubPesel)) ?
                URL + 'search?dataOd=' + params.dataOd + '&dataDo=' + params.dataDo + '&nipPesel=' + params.nipLubPesel
                :
                URL + 'search?dataOd=' + params.dataOd + '&dataDo=' + params.dataDo,
        });
    },

    pobierzPozycjeFaktury(rok, miesiac, symbolDokMag, numerDokMag) {
        return axios({
            method: 'get',
            url: URL + "pozycje/search?rok=" + rok + "&miesiac=" + miesiac + "&symbDokMag=" + symbolDokMag + "&numDokMag=" + numerDokMag
        });
    },


    pobierzFakturyWystawioneNaBiletJednorazowy(idBi) {
        return axios({
            method: 'get',
            url: URL_CLIENT + "daneDokumentow/biletJednorazowy/" + idBi
        })
    },

    pobierzFaktureNaDanyBiletJednorazowy(idBi, tabF, fSymNum) {

        return `${URL_CLIENT}generujFakture/biletJednorazowy/${idBi}/${tabF}/${fSymNum}`

        /*return axios({
            method: 'get',
            url: `${URL_CLIENT}generujFakture/biletJednorazowy/${idBi}/${tabF}/${fSymNum}`
        })*/
    },

}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/fakturyBilety/FakturyBiletyService.js